import React from 'react';

export default function TestimonialsSection() {
  const testimonials = [
    {
      quote:
        'AMIVA got me 5 competing offers in just 2 weeks. Their 24/7 availability and transparent process made all the difference. Sold for 40% above my initial expectations.',
      author: 'Healthcare Practice Owner',
      role: '',
      company: '6x EBITDA',
      image: 'HC',
    },
    {
      quote:
        'The AMIVA+ platform gave me complete visibility into every buyer interaction. Mike was available at 2am when we needed to make critical decisions. Exceptional service.',
      author: 'Commercial Cleaning Owner',
      role: '',
      company: '8x EBITDA',
      image: 'CC',
    },
    {
      quote:
        "From first call to closing in 5 months. AMIVA's curated buyer network and negotiation expertise added an extra $2M to my exit value. Couldn't be happier.",
      author: 'Technology Founder',
      role: '',
      company: '11x EBITDA',
      image: 'TE',
    },
  ];

  return (
    <div className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Success Stories from <span className="text-gradient">Real Exits</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Join hundreds of business owners who have maximized their exit value with AMIVA
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="card-premium p-8 h-full flex flex-col hover:shadow-2xl transition-all duration-300 fade-in"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="flex-1">
                <div className="flex mb-4">
                  {[...Array(5)].map((_, i) => (
                    <svg
                      key={i}
                      className="w-5 h-5 text-yellow-400"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  ))}
                </div>
                <p className="text-gray-700 text-lg mb-6 italic">"{testimonial.quote}"</p>
              </div>

              <div className="flex items-center">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-blue-500 to-emerald-500 flex items-center justify-center text-white font-bold mr-4">
                  {testimonial.image}
                </div>
                <div>
                  <div className="font-semibold text-gray-900">{testimonial.author}</div>
                  {testimonial.role && (
                    <div className="text-sm text-gray-600">{testimonial.role}</div>
                  )}
                  <div className="text-xs text-blue-600 font-medium mt-1">
                    {testimonial.company}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-600 mb-6">
            Average client results:{' '}
            <span className="font-bold text-gray-900">3.5 competing offers</span> •
            <span className="font-bold text-gray-900"> 35% above initial offer</span> •
            <span className="font-bold text-gray-900"> 6 months to close</span>
          </p>
        </div>

        <div className="text-center mt-6">
          <p className="text-base text-gray-700 italic">
            Names have been redacted for confidentiality. More information available upon request.
          </p>
        </div>
      </div>
    </div>
  );
}
